import 'css-chunksrc/client/pages/projectPage/budgetPage/plannedBudget/tableRow/styles.scss';export default {
  "tableBody": "_tableBody_yi3vi_1",
  "smallLabel": "_smallLabel_yi3vi_10",
  "fillerCell": "_fillerCell_yi3vi_24",
  "group": "_group_yi3vi_30",
  "input": "_input_yi3vi_38",
  "warning": "_warning_yi3vi_58",
  "icon": "_icon_yi3vi_62",
  "value": "_value_yi3vi_67"
};